/**
 * cart-milestones.js
 *
 * Handles:
 * 1. Progress bar UI
 * 2. Automatic milestone gift add/remove
 * 3. Removing old gifts when the Customizer product is changed
 */

(function () {
  if (window.__cartMilestonesInit) return;
  window.__cartMilestonesInit = true;

  var ROOT =
    (window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root) ||
    '/';

  var POLL_MS = 1500;
  var isSyncing = false;

  /*
   * Shopify Buy X Get Y discount codes used for milestone gifts.
   * The JS adds the gift product to the cart; Shopify then makes
   * that gift free when the corresponding discount is applied.
   */
  var MILESTONE_DISCOUNT_999 = 'FOTGIFT999';
  var MILESTONE_DISCOUNT_1499 = 'FOTGIFT1499';
  var MILESTONE_DISCOUNT_CODES = [
    MILESTONE_DISCOUNT_999,
    MILESTONE_DISCOUNT_1499
  ];

  /*
   * Get current milestone configuration from the
   * Cart Drawer section settings.
   */
  function getConfig() {
    var el = document.querySelector('[data-cart-milestones]');

    if (!el) return null;

    return {
      el: el,

      sectionId: el.getAttribute('data-section-id'),

      m1: parseInt(el.getAttribute('data-m1'), 10) || 0,
      m2: parseInt(el.getAttribute('data-m2'), 10) || 0,
      m3: parseInt(el.getAttribute('data-m3'), 10) || 0,

      gift2VariantId:
        parseInt(el.getAttribute('data-gift2-variant-id'), 10) || 0,

      gift3aVariantId:
        parseInt(el.getAttribute('data-gift3a-variant-id'), 10) || 0,

      gift3bVariantId:
        parseInt(el.getAttribute('data-gift3b-variant-id'), 10) || 0
    };
  }

  /*
   * Money formatting
   */
  function formatMoney(cents) {
    var amount = Math.max(Math.round(cents / 100), 0);

    return '₹' + amount.toLocaleString('en-IN');
  }

  /*
   * Get live cart
   */
  function fetchCart() {
    return fetch(ROOT + 'cart.js', {
      headers: {
        Accept: 'application/json'
      }
    }).then(function (r) {
      return r.json();
    });
  }

  /*
   * Calculate qualifying subtotal.
   *
   * Milestone gifts are excluded from the subtotal.
   */
  function qualifyingSubtotal(cart) {
    var giftTotal = 0;

    cart.items.forEach(function (item) {
      var isGift =
        item.properties &&
        item.properties._milestone_gift === 'true';

      if (isGift) {
        giftTotal += item.line_price;
      }
    });

    return Math.max(cart.total_price - giftTotal, 0);
  }

  /*
   * Find a particular configured gift in the cart.
   */
  function findGiftLine(cart, variantId) {
    if (!variantId) return null;

    return (
      cart.items.find(function (item) {
        return (
          item.variant_id === variantId &&
          item.properties &&
          item.properties._milestone_gift === 'true'
        );
      }) || null
    );
  }

  /*
   * Add milestone gift
   */
  function addGift(variantId, tier) {
    if (!variantId) {
      return Promise.resolve();
    }

    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },

      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,

            properties: {
              _milestone_gift: 'true',
              _milestone_tier: String(tier)
            }
          }
        ]
      })
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (body) {
          throw new Error(
            'cart/add.js failed for variant ' +
              variantId +
              ': ' +
              JSON.stringify(body)
          );
        });
      }

      return r.json();
    });
  }

  /*
   * Remove cart line
   */
  function removeLine(lineKey) {
    return fetch(ROOT + 'cart/change.js', {
      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },

      body: JSON.stringify({
        id: lineKey,
        quantity: 0
      })
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (body) {
          throw new Error(
            'cart/change.js failed for line ' +
              lineKey +
              ': ' +
              JSON.stringify(body)
          );
        });
      }

      return r.json();
    });
  }

  /*
   * Change the quantity of a cart line.
   *
   * Milestone gifts are always intended to have quantity 1.
   */
  function changeLineQuantity(lineKey, quantity) {
    return fetch(ROOT + 'cart/change.js', {
      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },

      body: JSON.stringify({
        id: lineKey,
        quantity: quantity
      })
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (body) {
          throw new Error(
            'cart/change.js quantity update failed for line ' +
              lineKey +
              ': ' +
              JSON.stringify(body)
          );
        });
      }

      return r.json();
    });
  }

  /*
   * Return the discount code that should be active for the
   * current milestone tier.
   */
  function getTargetDiscountCode(config, subtotal) {
    if (config.m3 > 0 && subtotal >= config.m3) {
      return MILESTONE_DISCOUNT_1499;
    }

    if (config.m2 > 0 && subtotal >= config.m2) {
      return MILESTONE_DISCOUNT_999;
    }

    return '';
  }

  /*
   * Check whether the milestone discount needs to be synced.
   */
  function milestoneDiscountNeedsSync(cart, targetCode) {
    var discountCodes = Array.isArray(cart.discount_codes)
      ? cart.discount_codes
      : [];

    var hasTarget = false;
    var hasOtherMilestoneCode = false;
    var targetApplicable = false;

    discountCodes.forEach(function (discount) {
      var code = String(
        discount && discount.code ? discount.code : ''
      ).toUpperCase();

      if (code === String(targetCode).toUpperCase()) {
        hasTarget = true;
        targetApplicable =
          discount.applicable !== false;
      }

      if (
        MILESTONE_DISCOUNT_CODES.indexOf(code) !== -1 &&
        code !== String(targetCode).toUpperCase()
      ) {
        hasOtherMilestoneCode = true;
      }
    });

    if (!targetCode) {
      return hasOtherMilestoneCode;
    }

    return !hasTarget || !targetApplicable || hasOtherMilestoneCode;
  }

  /*
   * Apply/remove only the milestone discount codes.
   *
   * Any other discount codes already on the cart are preserved.
   */
  function syncMilestoneDiscount(cart, targetCode) {
    var discountCodes = Array.isArray(cart.discount_codes)
      ? cart.discount_codes
      : [];

    var otherCodes = [];

    discountCodes.forEach(function (discount) {
      var code = String(
        discount && discount.code ? discount.code : ''
      ).trim();

      if (!code) return;

      if (
        MILESTONE_DISCOUNT_CODES.indexOf(code.toUpperCase()) === -1
      ) {
        otherCodes.push(code);
      }
    });

    if (targetCode) {
      otherCodes.push(targetCode);
    }

    var discountValue = otherCodes.join(', ');

    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },

      body: JSON.stringify({
        discount: discountValue
      })
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (body) {
          throw new Error(
            'cart/update.js discount sync failed: ' +
              JSON.stringify(body)
          );
        });
      }

      return r.json();
    });
  }

  /*
   * Progress bar UI
   */
  function renderProgressUI(config, subtotal) {
    var el = config.el;

    if (!el || !config.m3) return;

    var unlocked1 = subtotal >= config.m1;
    var unlocked2 = subtotal >= config.m2;
    var unlocked3 = subtotal >= config.m3;

    var pct = Math.min(
      (subtotal / config.m3) * 100,
      100
    );

    var message;

    if (unlocked3) {
      message =
        'All rewards unlocked — Free Shipping + 2 Free Gifts! 🎉';
    } else if (unlocked2) {
      message =
        'Free gift unlocked! Add ' +
        formatMoney(config.m3 - subtotal) +
        ' more to unlock 2 free gifts.';
    } else if (unlocked1) {
      message =
        'Free shipping unlocked! Add ' +
        formatMoney(config.m2 - subtotal) +
        ' more for a free gift.';
    } else {
      message =
        'Add ' +
        formatMoney(config.m1 - subtotal) +
        ' more to unlock free shipping.';
    }

    var messageEl =
      el.querySelector('.cart-milestones__message');

    if (messageEl) {
      messageEl.textContent = message;
    }

    var fillEl =
      el.querySelector('.cart-milestones__fill');

    if (fillEl) {
      fillEl.style.width = pct + '%';
    }

    var markers =
      el.querySelectorAll('.cart-milestones__marker');

    if (markers[0]) {
      markers[0].classList.toggle(
        'is-unlocked',
        unlocked1
      );
    }

    if (markers[1]) {
      markers[1].classList.toggle(
        'is-unlocked',
        unlocked2
      );
    }

    if (markers[2]) {
      markers[2].classList.toggle(
        'is-unlocked',
        unlocked3
      );
    }
  }

  /*
   * Refresh visible cart drawer.
   */
  function refreshDrawerSection(sectionId) {
    if (!sectionId) {
      return Promise.resolve();
    }

    var separator =
      window.location.search ? '&' : '?';

    var url =
      window.location.pathname +
      window.location.search +
      separator +
      'section_id=' +
      sectionId;

    return fetch(url, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc =
          new DOMParser().parseFromString(
            html,
            'text/html'
          );

        /*
         * Cart items
         */
        var next =
          doc.getElementById(
            'CartDrawer-CartItems'
          );

        var current =
          document.getElementById(
            'CartDrawer-CartItems'
          );

        if (next && current) {
          current.replaceWith(next);
        }

        /*
         * Footer
         */
        var nextFooter =
          doc.querySelector(
            '.cart-drawer__footer'
          );

        var currentFooter =
          document.querySelector(
            '.cart-drawer__footer'
          );

        if (nextFooter && currentFooter) {
          currentFooter.replaceWith(
            nextFooter
          );
        }

        /*
         * Cart count
         */
        var nextCount =
          doc.querySelector(
            '[data-cart-text]'
          );

        var currentCount =
          document.querySelector(
            '[data-cart-text]'
          );

        if (nextCount && currentCount) {
          currentCount.innerHTML =
            nextCount.innerHTML;
        }
      });
  }

  /*
   * MAIN RECONCILE FUNCTION
   */
  function reconcile() {
    var config = getConfig();

    if (!config || isSyncing) {
      return;
    }

    fetchCart()
      .then(function (cart) {
        /*
         * Calculate subtotal WITHOUT milestone gifts.
         */
        var subtotal =
          qualifyingSubtotal(cart);

        /*
         * Always update progress bar.
         */
        renderProgressUI(
          config,
          subtotal
        );

        /*
         * Determine current milestone.
         */
        var wantsTier3 =
          config.m3 > 0 &&
          subtotal >= config.m3;

        var wantsTier2 =
          !wantsTier3 &&
          config.m2 > 0 &&
          subtotal >= config.m2;

        /*
         * These are the ONLY gifts that are allowed
         * for the current milestone.
         */
        var allowedGiftIds = [];

        if (wantsTier3) {
          if (config.gift3aVariantId) {
            allowedGiftIds.push(
              config.gift3aVariantId
            );
          }

          if (config.gift3bVariantId) {
            allowedGiftIds.push(
              config.gift3bVariantId
            );
          }
        } else if (wantsTier2) {
          if (config.gift2VariantId) {
            allowedGiftIds.push(
              config.gift2VariantId
            );
          }
        }

        /*
         * Actions to perform.
         */
        var actions = [];

        /*
         * =====================================================
         * REMOVE OLD / INVALID GIFTS
         * =====================================================
         *
         * This is the new part.
         *
         * If Customizer previously had:
         *
         *     Sweetcorn
         *
         * and now has:
         *
         *     Banana
         *
         * Sweetcorn still exists in the cart with
         * _milestone_gift = true.
         *
         * Since Sweetcorn's variant ID is NOT in
         * allowedGiftIds, it gets removed.
         */
        cart.items.forEach(function (item) {
          var isMilestoneGift =
            item.properties &&
            item.properties._milestone_gift ===
              'true';

          var isConfiguredRewardVariant =
            [
              config.gift2VariantId,
              config.gift3aVariantId,
              config.gift3bVariantId
            ].indexOf(item.variant_id) !== -1;

          /*
           * Reward-only products should never remain in the cart
           * as normal paid items.
           */
          if (
            isConfiguredRewardVariant &&
            !isMilestoneGift
          ) {
            actions.push(function () {
              return removeLine(item.key);
            });

            return;
          }

          if (!isMilestoneGift) {
            return;
          }

          var isAllowed =
            allowedGiftIds.indexOf(
              item.variant_id
            ) !== -1;

          if (!isAllowed) {
            actions.push(function () {
              return removeLine(
                item.key
              );
            });
          }
        });

        /*
         * =====================================================
         * CHECK CURRENTLY CONFIGURED GIFTS
         * =====================================================
         */
        var gift2Line =
          findGiftLine(
            cart,
            config.gift2VariantId
          );

        var gift3aLine =
          findGiftLine(
            cart,
            config.gift3aVariantId
          );

        var gift3bLine =
          findGiftLine(
            cart,
            config.gift3bVariantId
          );

        /*
         * =====================================================
         * ENFORCE MILESTONE GIFT QUANTITY = 1
         * =====================================================
         */
        [
          gift2Line,
          gift3aLine,
          gift3bLine
        ].forEach(function (giftLine) {
          if (!giftLine) return;

          if (giftLine.quantity !== 1) {
            actions.push(function () {
              return changeLineQuantity(
                giftLine.key,
                1
              );
            });
          }
        });

        /*
         * =====================================================
         * MILESTONE 2
         * =====================================================
         */
        if (
          wantsTier2 &&
          config.gift2VariantId &&
          !gift2Line
        ) {
          actions.push(function () {
            return addGift(
              config.gift2VariantId,
              2
            );
          });
        }

        /*
         * =====================================================
         * MILESTONE 3 - GIFT 1
         * =====================================================
         */
        if (
          wantsTier3 &&
          config.gift3aVariantId &&
          !gift3aLine
        ) {
          actions.push(function () {
            return addGift(
              config.gift3aVariantId,
              3
            );
          });
        }

        /*
         * =====================================================
         * MILESTONE 3 - GIFT 2
         * =====================================================
         */
        if (
          wantsTier3 &&
          config.gift3bVariantId &&
          !gift3bLine
        ) {
          actions.push(function () {
            return addGift(
              config.gift3bVariantId,
              3
            );
          });
        }

        var targetDiscountCode =
          getTargetDiscountCode(
            config,
            subtotal
          );

        /*
         * The discount must be synced after gift add/remove
         * actions so Shopify evaluates the BXGY discount with
         * the final gift lines already in the cart.
         */
        var discountNeedsSync =
          milestoneDiscountNeedsSync(
            cart,
            targetDiscountCode
          );

        /*
         * Nothing needs changing.
         */
        if (
          actions.length === 0 &&
          !discountNeedsSync
        ) {
          return;
        }

        /*
         * Prevent multiple simultaneous cart updates.
         */
        isSyncing = true;

        /*
         * Execute gift actions one by one.
         */
        return actions
          .reduce(function (
            chain,
            action
          ) {
            return chain.then(action);
          }, Promise.resolve())

          /*
           * Get the final cart before syncing the discount.
           */
          .then(function () {
            return fetchCart();
          })

          /*
           * Apply the correct milestone discount.
           */
          .then(function (freshCart) {
            var finalSubtotal =
              qualifyingSubtotal(
                freshCart
              );

            var finalTargetDiscount =
              getTargetDiscountCode(
                config,
                finalSubtotal
              );

            if (
              !milestoneDiscountNeedsSync(
                freshCart,
                finalTargetDiscount
              )
            ) {
              return freshCart;
            }

            return syncMilestoneDiscount(
              freshCart,
              finalTargetDiscount
            );
          })

          /*
           * Refresh visible drawer.
           */
          .then(function () {
            return refreshDrawerSection(
              config.sectionId
            );
          })

          /*
           * Get the final cart again.
           */
          .then(function () {
            return fetchCart();
          })

          /*
           * Repaint progress bar using final cart.
           */
          .then(function (freshCart) {
            renderProgressUI(
              config,
              qualifyingSubtotal(
                freshCart
              )
            );
          })

          .finally(function () {
            isSyncing = false;
          });
      })
      .catch(function (err) {
        console.error(
          '[cart-milestones]',
          err
        );

        isSyncing = false;
      });
  }

  /*
   * IMPORTANT:
   * Keep the original polling.
   */
  function initCartMilestones() {
    reconcile();

    setInterval(
      reconcile,
      POLL_MS
    );
  }

  /*
   * Start after DOM is ready.
   */
  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initCartMilestones
    );
  } else {
    initCartMilestones();
  }

  /*
   * Public refresh hook.
   */
  window.CartMilestones = {
    refresh: reconcile
  };
})();